import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const parseBooleanParam = value => {
  if (value === null) {
    return null;
  }

  return value.trim().toLowerCase() === 'true' || value.trim() === '1';
};

const DataReceiver = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Pobieranie danych z parametrów URL
    const receivedData = {
      name: searchParams.get('name'),
      surname: searchParams.get('surname'),
      maidaneName: searchParams.get('maidaneName'),
      birthDate: searchParams.get('birthDate'),
      deathDate: searchParams.get('deathDate'),
      sex: searchParams.get('sex'),
      burial: parseBooleanParam(searchParams.get('burial')),
      massDate: searchParams.get('massDate'),
      massTime: searchParams.get('massTime'),
      massPlace: searchParams.get('massPlace'),
      massPlaceAddress: searchParams.get('massPlaceAddress'),
      funeralPlace: searchParams.get('funeralPlace'),
      funeralPlaceAddress: searchParams.get('funeralPlaceAddress')
    };

    // Sprawdzenie czy są jakieś dane do zapisania
    const hasData = Object.values(receivedData).some(value => value !== null);

    if (hasData) {
      // Zapisywanie danych w sessionStorage
      sessionStorage.setItem('funeralFormData', JSON.stringify(receivedData));
      
      // Dodatkowe zabezpieczenie - zapisanie timestamp
      sessionStorage.setItem('funeralFormDataTimestamp', Date.now().toString());
    }

    // Przekierowanie do /login
    navigate('/personForm', { replace: true });

  }, [searchParams, navigate]);

  return null; // Komponent nie renderuje niczego
};

export default DataReceiver;
